module.exports = __webpack_public_path__ + "img/KUCE-CROP-02.56682719.png";